const countKFormatter = (count: string | number) =>
  Number(count) < 1000 ? count + "" : `${(+count / 1000)?.toFixed(1)}‌k`;

export default countKFormatter;
